import { CalendarEventData } from "./CalendarEventData";

function compactUtc(dt: Date): string {
  return dt.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
}

function isoUtc(dt: Date): string {
  return dt.toISOString().replace(/\.\d{3}Z$/, "Z");
}

export function buildGoogleCalendarUrl(event: CalendarEventData): string {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    dates: `${compactUtc(event.startUtc)}/${compactUtc(event.endUtc)}`,
  });
  if (event.description) params.set("details", event.description);
  if (event.location) params.set("location", event.location);
  return `https://calendar.google.com/calendar/render?${params}`;
}

export function buildOutlookUrl(event: CalendarEventData): string {
  const params = new URLSearchParams({
    subject: event.title,
    startdt: isoUtc(event.startUtc),
    enddt: isoUtc(event.endUtc),
  });
  if (event.description) params.set("body", event.description);
  if (event.location) params.set("location", event.location);
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params}`;
}


